import type { PropertyJournalEvent } from "@zplanem/responses"
import { DocumentEventRow } from "./event-rows/document-event-row"
import { InspirationEventRow } from "./event-rows/inspiration-event-row"
import { MemberInvitedRow } from "./event-rows/member-invited-row"
import { MemberJoinedRow } from "./event-rows/member-joined-row"
import { ProjectArchiveRow } from "./event-rows/project-archive-row"
import { ProjectCostRow } from "./event-rows/project-cost-row"
import { ProjectCreatedRow } from "./event-rows/project-created-row"
import { ProjectMemberRow } from "./event-rows/project-member-row"
import { ProjectStatusChangedRow } from "./event-rows/project-status-changed-row"
import { PropertyCreatedRow } from "./event-rows/property-created-row"
import { TicketEventRow } from "./event-rows/ticket-event-row"
import { UnknownEventRow } from "./event-rows/unknown-event-row"
import { VisualizationEventRow } from "./event-rows/visualization-event-row"

function TypeRow({ event }: { event: PropertyJournalEvent }) {
	switch (event.type) {
		case "property.created":
			return <PropertyCreatedRow event={event} />
		case "member.invited":
			return <MemberInvitedRow event={event} />
		case "member.joined":
			return <MemberJoinedRow event={event} />
		case "project.created":
			return <ProjectCreatedRow event={event} />
		case "project.status_changed":
			return <ProjectStatusChangedRow event={event} />
		case "project.cost_proposed":
		case "project.cost_accepted":
		case "project.cost_rejected":
		case "project.paid":
			return <ProjectCostRow event={event} />
		case "project.member_added":
		case "project.member_removed":
			return <ProjectMemberRow event={event} />
		case "project.archived":
		case "project.unarchived":
			return <ProjectArchiveRow event={event} />
		case "inspiration.created":
		case "inspiration.deleted":
			return <InspirationEventRow event={event} />
		case "visualization.created":
		case "visualization.deleted":
			return <VisualizationEventRow event={event} />
		case "document.created":
		case "document.deleted":
		case "document.updated":
			return <DocumentEventRow event={event} />
		case "ticket.created":
		case "ticket.status_changed":
		case "ticket.assigned":
			return <TicketEventRow event={event} />
		default:
			return <UnknownEventRow event={event} />
	}
}

export function JournalRow({
	event,
	sourceLabel,
}: {
	event: PropertyJournalEvent
	sourceLabel?: string
}) {
	return (
		<div
			data-event-id={event.id}
			data-source-marker={sourceLabel ?? undefined}
			className="border-b border-border last:border-b-0"
		>
			{sourceLabel ? (
				<div className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground/70 pt-3 -mb-2 truncate">
					{sourceLabel}
				</div>
			) : null}
			<TypeRow event={event} />
		</div>
	)
}
